import { ActionsUnion, createAction } from '../../../redux/customActions';
import { OfficeLanguage } from '../../config/appConfig';

export const Actions = {
    userLangUpdating: () => createAction('userInfo/langUpdateRequested'),
    userLangFailed: () => createAction('userInfo/langUpdateRequestFailed'),
    userLangSet: (language: OfficeLanguage) =>
        createAction('userInfo/langUpdateRequestSucceed', { language }),
};

export type ActionsType = ActionsUnion<typeof Actions>;
